import React from 'react'
import {haploGroup} from './Util';

export default class DetailMiHaplo extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      detail: props.detail
    }
  }

  printDetail() {

    var domClone = document.getElementById("c-modal__content").cloneNode(true);
    var printSection = document.getElementById("r-wrapper");
    var noPrint = document.getElementById("l-wrapper");
    printSection.innerHTML = "";
    printSection.appendChild(domClone);

    noPrint.style.display = "none";
    for(var i=0; i<document.getElementById("c-modal__content").getElementsByTagName('canvas').length; i++){
      var canvasf = document.getElementById("c-modal__content").getElementsByTagName('canvas')[i];
      var canvast = printSection.getElementsByTagName('canvas')[i];
      var image = canvasf.getContext('2d').getImageData(0, 0, canvasf.width, canvasf.height);
      canvast.getContext('2d').putImageData(image, 0, 0);
    }



    window.print();

    printSection.innerHTML = "";
    noPrint.style.display = "block";
    return false;
  }

  render() {

    const r = this.state.detail;

    const u = r.unit;
    const unitName = u.name;
    const unitSummary = u.summary.split('<br>');
    const unitExplanation = u.explanation.split('<br>');
    const haploDescription = r.haplo_description ? r.haplo_description.split('<br>') : null;
    const levelName = r.split_level_name[0] + r.split_level_name[1] + r.split_level_name[2];
    const references = u.references;
    const groupSplit = r.split_level_name[1].match(/^([A-Za-z0-9]+)グループ（([A-Za-z0-9]+)）$/) //"M9グループ（M9）"から"M9"を返す正規表現
    let group = { group: "", sub: "" };
    if(groupSplit) {
      group = { group: groupSplit[1], sub: groupSplit[2] };
    }
    let haploImage = haploGroup(group.group);

    let loopKey = 0;
    return (
      <div className="wrap">

        <div className="detail_header">
          <div className="wrap cfx">
            <h2 className="header_title">{unitName}</h2>
              <div className="header_btnwrap">
                {<span className="btn detail_print" onClick={this.printDetail.bind()}>印刷する</span>}
              </div>
          </div>
        </div>

        <div className="detailwrap">
          <div className="sect">
            <h3>あなたの判定結果</h3>
            <p className="detail_risk_result">{levelName}</p>
          </div>

          <div className="sect">
            <h3>結果説明</h3>
            <div className="descrpt">
              <p>
                {unitExplanation.length > 0 && unitExplanation.map(s => {
                  return (<span key={"unitExplanation" + loopKey++}>{s}<br/></span>)
                })}
              </p>
              <p className="center"><img src={haploImage} /></p>
            </div>
          </div>

          <div className="sect">
            <h3>項目概要</h3>
            <div className="descrpt">
              <p>
                {unitSummary.length > 0 && unitSummary.map(s => {
                  return (<span key={"unitSummary" + loopKey++}>{s}<br/></span>)
                })}
              </p>
              <p className="center haplo_tree"><img src={`https://s3-ap-northeast-1.amazonaws.com/genesis2/images/detail/unit_id_${u.id}.png`}  alt="項目概要" /></p>
            </div>
          </div>

          <div className="sect">
            <h3>{r.haplo_title}</h3>
            <div className="descrpt">
              <p>
                {haploDescription && haploDescription.length > 0 && haploDescription.map(s => {
                  return (<span key={"haploDescription" + loopKey++}>{s}<br/></span>)
                })}
              </p>
            </div>
          </div>

          <div className="sect">
            <h3>参考文献</h3>
            <div className="descrpt">
              <ul>
                {references.map(ref => {
                  return <li key={ref.title}>{ref.title}</li>
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailMiHaplo.js